import { ChevronRight } from 'react-feather';

import { ProductSectionProps } from '@/Main/types/ProductSectionTypes';
import LinkButton from '@/shared/components/UI/LinkButton';
import ProductCard from '@/shared/components/UI/ProductCard';

const ProductSection = ({
  productList,
  title,
  categoryId,
}: ProductSectionProps) => {
  return (
    <section className="mx-auto mt-[80px] max-w-5xl">
      <div className="flex items-center justify-between">
        <h2 className="text-[1.5rem] font-black text-[#95699f]">{title}</h2>
        <LinkButton
          to={`/productlist/${categoryId}?${categoryId === 0 ? 'tag=pre&' : ''}categoryName=${title}`}
          variant="text"
          className="gap-[4px] text-[0.875rem] hover:text-[#666]"
          rightIcon={<ChevronRight size={20} color="#666666" strokeWidth={1} />}
        >
          VIEW ALL
        </LinkButton>
      </div>
      <div className="mx-auto mt-[40px] grid max-w-5xl grid-cols-4 gap-2">
        {productList.map((product) => (
          <ProductCard key={product.productUuid} product={product} />
        ))}
      </div>
    </section>
  );
};

export default ProductSection;
